import {
	BPanel,
	Button,
	Form,
	FormGroup,
	Col,
	ControlLabel,
	FormControl,
	Breadcrumb,
} from '@sketchpixy/rubix';
import { Router, Link, browserHistory, withRouter } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Reactive } from '../common/Reactive.mixin.js';

import { Meteor } from 'meteor/meteor';

import { Promotions } from '../../collections/flights-type/promotions';

@withRouter
@Reactive({
	subscriptions: ["flights-type"]
})
export default class PromotionsFormPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		if(this.props.params.id)
			this.promotion = Promotions.find({_id: this.props.params.id}).fetch()[0];
		else
			this.promotion = {};
	}

	handleSubmit(e) {
		e.preventDefault();

		let params = {};
		let message = null;
		let method = null;

		params.attributes = {};
		_.each(this.refs, (ref, key) => {
			params.attributes[key] = ReactDOM.findDOMNode(ref).value.trim();   
		});


		if(this.props.params.id) {
			message = "Le tarif a été modifié avec succès.";
			method = "promotions.update";
			params._id = this.props.params.id;
		}
		else {
			message = "Le tarif a été ajouté avec succès.";
			method = "promotions.insert";
			params.attributes["createdAt"] = new Date();
		}

		Meteor.call(method, params, (function (err, _id) {

			if (err) {
				Messenger().post({
					message: err,
					type: "error"
				});
				return; 
			}

			Messenger().post({
				message: message,
				type: "success"
			});
			
			this.props.router.push('/promotions');
		}).bind(this));

	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/promotions">Tarifs</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Ajouter/Modifier un Tarif
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Ajouter/Modifier un tarif">
					<Form horizontal onSubmit={this.handleSubmit.bind(this)}>
						<FormGroup controlId="formHorizontalEmail">
							<Col componentClass={ControlLabel} sm={2}>
								Titre du tarif
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="title" defaultValue={this.promotion.title} />
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Pourcentage de réduction
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="percentage" defaultValue={this.promotion.percentage}/>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Nombre min. de passagers
							</Col>
							<Col sm={10}>
								<FormControl type="text" ref="constraintOfUsers" defaultValue={this.promotion.constraintOfUsers}/>
							</Col>
						</FormGroup>

						<FormGroup controlId="formHorizontalPassword">
							<Col componentClass={ControlLabel} sm={2}>
								Référence*
							</Col>
							<Col sm={2}>
								<FormControl type="text" ref="reference" defaultValue={this.promotion.reference}/>
							</Col>
							<Col sm={8}>
								<small>* laisser vide si cette promotion n'existe pas sur le site.</small>
							</Col>
						</FormGroup>

						<FormGroup>
							<Col smOffset={2} sm={10}>
								<Button type="submit">
									Enregistrer
								</Button>
							</Col>
						</FormGroup>
					</Form>
				</BPanel>
			</div>
		);
	}
}

PromotionsFormPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/promotions/PromotionsForm.page.js
 **/